import { Account } from 'model/IChat';
import React from 'react';
import OtherLocalsSuccessSection from 'reusable-components/forms/ContactHostForm/OtherLocalsSuccessSection/OtherLocalsSuccessSection';
import useLocalsAvailableForDateTime from 'reusable-components/forms/ContactHostForm/RequestPersonalizedOfferForm/hooks/useLocalsAvailableForDateTime';
import { CONTACT_HOST_SOURCES } from '~/constants';

interface OtherlocalsSuccessSectionContainerProps {
  hostId: string;
  hosts: Account[];
  experienceId: string;
  date: string;
  time: string;
  source: CONTACT_HOST_SOURCES;
}

function OtherLocalsSuccessSectionContainer({
  hostId,
  hosts,
  experienceId,
  date,
  time,
  source,
}: OtherlocalsSuccessSectionContainerProps) {
  const { isLoading, availableHosts } = useLocalsAvailableForDateTime({
    experienceId,
    date,
    time,
    hostId,
  });
  if (isLoading || availableHosts.length === 0) {
    return null;
  }

  const images =
    hosts
      ?.filter((host) => availableHosts.includes(host.id))
      .map((host) => host.photo) || [];

  return (
    <OtherLocalsSuccessSection
      images={images}
      availableHosts={availableHosts}
      source={source}
    />
  );
}

export default OtherLocalsSuccessSectionContainer;
